import React from 'react';
import { connect } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import DndWrapper from '../../components/DndWrapper';
import Login from '../Login';
import Landing from '../Landing';
import ForgotPassword from '../ForgotPassword';
import { AppRoutes } from '../../constants/AppConstant';
import ResetPassword from '../ResetPassword';
import Home from '../Home';

interface AppInterface {
  token?: string;
  currentToken?: string;
}

const App: React.FC<AppInterface> = props => {
  return (
    <DndWrapper>
      <BrowserRouter>
        {/* @ts-ignore */}
        <Switch>
          {/* @ts-ignore */}
          <Route path="/login" render={() => <Login />} />
          {/* @ts-ignore */}
          <Route exact path={`${AppRoutes.ForgotPassword}`} render={() => <ForgotPassword />} />
          {/* @ts-ignore */}
          <Route exact path={`${AppRoutes.ResetPassword}`} render={() => <ResetPassword />} />
          {/* "/" is not a page of its own — send it to Home. */}
          {/* @ts-ignore */}
          <Route
            exact
            path="/"
            render={() => (!props.token ? <Redirect to="/login" /> : <Redirect to={AppRoutes.Home} />)}
          />
          {/*
            Every other path is a page inside the app shell, so hand it to
            Landing and let its own Switch pick the page. This used to be a
            blanket redirect to Home, which meant the URL was only honoured
            while navigating inside an already-mounted app: refreshing (or
            opening a link to) any page bounced the user back to the homepage.
          */}
          {/* @ts-ignore */}
          <Route path="/" render={() => (!props.token ? <Redirect to="/login" /> : <Landing />)} />
        </Switch>
      </BrowserRouter>
    </DndWrapper>
  );
};

const mapStateToProps = ({ globalReducer }: any) => ({
  token: globalReducer.token,
});

export default connect(mapStateToProps)(App);
